import { types as t, flow } from 'mobx-state-tree';
import api from 'api';
import Company from './Company';
import StoreState from './StoreState';
import uiStore from './UIStore';

const CompanyStore = t
  .model('CompanyStore', {
    current: t.maybe(Company),
    state: t.optional(StoreState, 'initial'),
  })
  .actions((self) => ({
    setCurrent: flow(function* (name) {
      if (self.state !== 'initial' || (self.current && self.current.name === name)) return;

      self.state = 'loading';
      const res = yield api.companies.loadCompany(name);
      if (res.status === 404) {
        return;
      }
      uiStore.setTheme(res.data.theme);
      self.current = res.data;
      self.state = 'loaded';
    }),
  }));

export { CompanyStore };
export default CompanyStore.create();
